import { moduleFile } from "@lib/appconst"
import fileService from "@services/common/fileService"
import type { PagedResultDto } from "@services/dto/pagedResultDto"
import unitFacilityService from "@services/master-data/unitFacilityService"
import { action, makeAutoObservable, observable } from "mobx"

class UnitFacilityStore {
  @observable isLoading!: boolean
  @observable tableData!: PagedResultDto<any>
  @observable detailData!: any
  @observable listData!: any

  constructor() {
    makeAutoObservable(this)
    this.tableData = { items: [], totalCount: 0 }
    this.listData = []
  }

  @action
  async createOrUpdate(body: any, files?: any) {
    const result = await unitFacilityService.createOrUpdate(body)
    this.detailData = result
    const { uniqueId } = result
    if (files && files.length && uniqueId) {
      files.forEach(async (file) => {
        if (file.originFileObj !== undefined) {
          const fileUpload = file.originFileObj
          await fileService.upload(
            moduleFile.unitFacility,
            uniqueId,
            fileUpload
          )
        }
      })
      this.isLoading = false
    }

    if (!body.id) {
      this.tableData.items.push(result)
    } else {
      this.tableData.items = this.tableData.items.map((x) => {
        if (x.id === body.id) x = result
        return x
      })
    }
  }

  @action
  async newUnitFacility() {
    this.detailData = {
      id: 0,
    }
  }

  @action
  async emptyDetail() {
    this.detailData = {}
  }

  @action
  async active(id: number, isActive) {
    await unitFacilityService.activate(id, isActive)
  }

  @action
  async get(id: number) {
    const result = await unitFacilityService.get(id)
    this.detailData = result
  }

  @action
  async getAll(params: any) {
    this.isLoading = true
    const result = await unitFacilityService
      .getAll(params)
      .finally(() => (this.isLoading = false))
    this.tableData = result
  }
  @action
  async getList(params: any) {
    this.isLoading = true
    const result = await unitFacilityService
      .getList(params)
      .finally(() => (this.isLoading = false))
    this.listData = result
  }
}

export default UnitFacilityStore
